import cn from "classnames"
import React from "react"
import { SpinnerContainer } from "swiipe.portal.shared"
import "./DigitealDetailsSection.scss"

interface IDigitealSection {
    title: string
    description: string
    children?: React.ReactNode
    isLoading?: boolean
    sectionClassName?: string
}

const DigitealDetailsSection = ({ title, description, sectionClassName, isLoading = false, children }: IDigitealSection) => {
    return (
        <section className="digiteal-details-section">
            <div className="digiteal-details-section__header">
                <div>
                    <h4>{title}</h4>
                    <p className="digiteal-details-section__description">{description}</p>
                </div>
            </div>
            <SpinnerContainer
                showSpinner={isLoading}
                wrapperClassName={cn("digiteal-details-section__container", sectionClassName)}
                minHeight={100}
                maxHeight={100}
            >
                {children}
            </SpinnerContainer>
        </section>
    )
}

export default DigitealDetailsSection
